import { render, staticRenderFns } from "./expert-edit.vue?vue&type=template&id=17229d3b&scoped=true&"
import script from "./expert-edit.vue?vue&type=script&lang=ts&"
export * from "./expert-edit.vue?vue&type=script&lang=ts&"
import style0 from "./expert-edit.vue?vue&type=style&index=0&id=17229d3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17229d3b",
  null
  
)

export default component.exports